module.exports = __webpack_public_path__ + "img/unpinned.92cb6d00.svg";